import * as React from 'react';

import { Dropdown } from 'semantic-ui-react';

import { ErrorMsg } from '../';
import { localeData } from '../../../locales/data';
import { convertArrayFromDropdown } from '../../../shared/helpers';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface SelectProps {
  placeholder: string;
  handleChange: (event: any, options: any) => void;
  errors?: any[];
  value: any;
  options: any;
  tabindex?: number;
  name: string;
  fieldPos: number;
  id: string;
  label: string;
}

class Select extends React.Component<SelectProps> {
  handleChange = (_: any, { value }: any) => {
    const { fieldPos, name } = this.props;
    this.props.handleChange(value, { fieldPos, name });
  };

  componentDidMount() {
    const { fieldPos, name, value } = this.props;
    this.props.handleChange(value, { fieldPos, name });
  }

  render() {
    const { errors = [], options = [], value, placeholder, tabindex = 0, id, name, label } = this.props;

    return (
      <div className="form-content">
        <label htmlFor="gender" className="input__label">
          <FormattedMessageHelper tagName="span" id={label} defaultMessage={localeData.en[label]} />
          <sup>*</sup>
        </label>
        <Dropdown
          className="dropdown-custom"
          placeholder={placeholder}
          options={options && convertArrayFromDropdown(options)}
          selection={true}
          value={value}
          onChange={this.handleChange}
          name={name}
          searchInput={{ id }}
          tabIndex={tabindex}
        />
        <div className="form-radio__error">{errors.length !== 0 && <ErrorMsg errors={errors} />}</div>
        <div className="select__info_small">
          <FormattedMessageHelper tagName="span" id="account.gender.message" defaultMessage={localeData.en['account.gender.message']} />
        </div>
      </div>
    );
  }
}

export default Select;
